import React, { Component } from 'react';
import './LayoutList.css';
import BlogCell from './BlogCell';
import InfoCell from './InfoCell';
import { getShadowItem } from '../utils';

class LayoutList extends Component {
  render() {

    const {
      items,
      hasBlogCell,
    } = this.props;
    const shadowItem = getShadowItem(items);
    const rows = [];
  
    let key = 0;
    for (const item of items) {
      if (hasBlogCell) {
        rows.push(
          <BlogCell key={key++} item={item} shadowItem={shadowItem} />
        );
      } else {
        rows.push(
          <InfoCell key={key++} item={item} shadowItem={shadowItem} />
        );
      }
    }
    return (
      <div className="lp-layout-list">
        {rows}
      </div>
    );
  }
}

export default LayoutList;



// WEBPACK FOOTER //
// ./src/components/LayoutList.js